import React from "react";
import { Link } from "react-router-dom";
import wordmark from "../../../assets/brand/cache-wordmark.svg";
import { useFitScale, fitScaleStyle } from "../../ForBrands/useFitScale";
import "../../ForBrands/brandMode.css";

// The Player Index frame both indexes share, so they look the same side by
// side: the signed-in one (PlayerIndexLayout, "/" and /business/dashboard)
// and the public one (/p/business/dashboard). A 72px topbar with the
// wordmark and a right-hand slot, over a fit-to-width page with the V2
// shell gutters. The frame imports nothing from the store, so the no-login
// page can use it. homeLabel names the wordmark link for screen readers; a
// caller whose homeTo is not the Player Index names where it goes.
const GUTTERS = "px-5 sm:px-8 lg:px-12 min-[1440px]:px-[122px]";

const IndexShell = ({ homeTo, homeLabel = "Player Index", right, children }) => {
  const fit = useFitScale();
  return (
    <div className="bm-root w-full min-w-0 max-w-full overflow-x-clip bg-white" style={fitScaleStyle(fit)}>
      <header className="border-b border-bm-border bg-white">
        <div className={`flex h-[72px] w-full items-center justify-between ${GUTTERS}`}>
          <Link to={homeTo} className="flex items-center" aria-label={homeLabel}>
            <img src={wordmark} alt="CACHE" className="h-[19px] w-[95px]" />
          </Link>
          <div className="flex items-center gap-4">{right}</div>
        </div>
      </header>
      <main className={`w-full min-w-0 max-w-full pb-[70px] ${GUTTERS}`}>{children}</main>
    </div>
  );
};

export default IndexShell;
